import { TBannerType } from 'components/BannerRecommendation'
import { Listing } from 'graphql/types'
import { getListingLoggingInfo } from 'lib/listing'
import logger from 'lib/logger'

type TRelatedBannerRecommendation = {
  listing: Listing
  photo?: number
  currentListingId: Pick<Listing, 'id'>
  bannerType: TBannerType
  origin?: string
  hasSimilars?: boolean
  hasRecommendations?: boolean
}

export const clickRelatedBannerRecommendationCardEvent = ({
  listing,
  currentListingId,
  bannerType,
  hasSimilars,
  hasRecommendations,
}: TRelatedBannerRecommendation) =>
  logger.action('listing-detail-view-featured-listing', {
    ...getListingLoggingInfo(listing),
    currentListingId,
    bannerType,
    hasSimilars,
    hasRecommendations,
  })

export const navigateListingCardGalleryEvent = ({
  listing,
  photo,
  currentListingId,
  bannerType,
  hasSimilars,
  hasRecommendations,
}: TRelatedBannerRecommendation) =>
  logger.action('listing-card-photos', {
    ...getListingLoggingInfo(listing),
    photo,
    currentListingId,
    bannerType,
    hasSimilars,
    hasRecommendations,
  })

export const clickMoreListingsEvent = ({
  listing,
  origin,
  bannerType,
  hasSimilars,
  hasRecommendations,
}: Pick<
  TRelatedBannerRecommendation,
  'listing' | 'origin' | 'bannerType' | 'hasSimilars' | 'hasRecommendations'
>) =>
  logger.action('listing-detail-more-listings-button', {
    ...getListingLoggingInfo(listing),
    origin,
    bannerType,
    hasSimilars,
    hasRecommendations,
  })

export const clickListingCardFavoriteEvent = ({
  listing,
  bannerType,
  hasSimilars,
  hasRecommendations,
}: Pick<
  TRelatedBannerRecommendation,
  'listing' | 'bannerType' | 'hasSimilars' | 'hasRecommendations'
>) =>
  logger.action('listing-detail-favorite-related-listing', {
    ...getListingLoggingInfo(listing),
    favorited: true,
    bannerType,
    hasSimilars,
    hasRecommendations,
  })

export const getAllRelatedListingsEvents = ({
  bannerType,
  currentListing,
  origin,
  hasSimilars,
  hasRecommendations,
}: {
  bannerType: TBannerType
  currentListing?: Listing
  origin: string
  hasSimilars?: boolean
  hasRecommendations?: boolean
}) => ({
  onSlideCards: (page: number, item: Listing) =>
    navigateListingCardGalleryEvent({
      listing: item,
      photo: page,
      currentListingId: currentListing?.id as Pick<Listing, 'id'>,
      bannerType,
      hasSimilars,
      hasRecommendations,
    }),
  onClickListingCard: (item: Listing) =>
    clickRelatedBannerRecommendationCardEvent({
      listing: item,
      currentListingId: currentListing?.id as Pick<Listing, 'id'>,
      bannerType,
      hasSimilars,
      hasRecommendations,
    }),
  onFavoriteListing: () =>
    clickListingCardFavoriteEvent({
      listing: currentListing || {},
      bannerType,
      hasSimilars,
      hasRecommendations,
    }),
  onClickRelated: () =>
    clickMoreListingsEvent({
      listing: currentListing || {},
      origin: origin,
      bannerType,
      hasSimilars,
      hasRecommendations,
    }),
})
